// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- Set once for this component */

.Combobox-module__Container__hnocg {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.Combobox-module__ComboboxContainer__MCfX3 {
    display: flex;
    flex-direction: column;
    gap: var(--ds-s);
    align-items: flex-start;
    width: 100%;
    min-width: 0;
}

.Combobox-module__LabelContainer__DymTC {
    display: flex;
    gap: var(--ds-xs);
    align-items: center;
    max-width: 100%;
}

.Combobox-module__TooltipIcon__QSp4k {
    color: var(--ds-input-label-tooltip-icon-color);
}

.Combobox-module__LabelDisabled__LO8s4 {
    color: var(--ds-input-disabled-label-color);
}

.Combobox-module__DescriptionDisabled__D6E9K {
    color: var(--ds-input-disabled-description-color);
}

.Combobox-module__LabelReadOnly__gZp6m {
    color: var(--ds-input-readonly-label-color);
}

.Combobox-module__DescriptionReadOnly__t4okI {
    color: var(--ds-input-readonly-description-color);
}

.Combobox-module__InputAndListContainer__LnP01 {
    width: 100%;
    min-width: 0;
}

.Combobox-module__FullWidth__IMLW6 {
    width: 100%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Combobox-module__Container__hnocg`,
	"ComboboxContainer": `Combobox-module__ComboboxContainer__MCfX3`,
	"LabelContainer": `Combobox-module__LabelContainer__DymTC`,
	"TooltipIcon": `Combobox-module__TooltipIcon__QSp4k`,
	"LabelDisabled": `Combobox-module__LabelDisabled__LO8s4`,
	"DescriptionDisabled": `Combobox-module__DescriptionDisabled__D6E9K`,
	"LabelReadOnly": `Combobox-module__LabelReadOnly__gZp6m`,
	"DescriptionReadOnly": `Combobox-module__DescriptionReadOnly__t4okI`,
	"InputAndListContainer": `Combobox-module__InputAndListContainer__LnP01`,
	"FullWidth": `Combobox-module__FullWidth__IMLW6`
};
export default ___CSS_LOADER_EXPORT___;
